import { useEffect } from "react";
import { toast } from "react-toastify";

declare const __APP_VERSION__: string;

const POLL_MS = 60_000;

export const useVersionCheck = (): void => {
  useEffect(() => {
    let dismissed = false;

    const check = async (): Promise<void> => {
      if (document.hidden || dismissed) return;
      try {
        const res = await fetch(`/version.json?t=${Date.now()}`, { cache: "no-store" });
        if (!res.ok) return;
        const { version } = (await res.json()) as { version: string };
        if (version && version !== __APP_VERSION__) {
          dismissed = true;
          toast.info("A new version is available. Click here to refresh.", {
            autoClose: false,
            closeOnClick: true,
            onClick: () => window.location.reload(),
          });
        }
      } catch {
        // Swallow transient network errors — we'll try again next interval
      }
    };

    const id = setInterval(check, POLL_MS);
    void check();
    return () => clearInterval(id);
  }, []);
};
